<template>
  <div>
    <b-form-group>
      <b-form-select v-model="selected" @change="loadLanguageAsync">
        <option v-for="(lang) in langs" :key="$t(`msg.${lang}`)" :value="lang">{{$t(`msg.${lang}`)}}</option>
      </b-form-select>
    </b-form-group>
  </div>
</template>
<script>
export default {
  data () {
    return {
      langs: ['en', 'ms', 'zh', 'ta', 'km', 'th', 'id', 'ar'],
      rtlLanguages: ['ar'],
      loadedLanguages: ['en'],
      selected: null,
      hideLang: []
    }
  },
  mounted () {
    if (this.$cookies.isKey('nedas_lang') && this.langs.includes(this.$cookies.get('nedas_lang'))) {
      this.loadLanguageAsync(this.$cookies.get('nedas_lang'))
      this.selected = this.$cookies.get('nedas_lang')
      this.$store.dispatch('home/setLanguage', this.selected)
    } else {
      this.$cookies.set('nedas_lang', 'en')
      this.selected = this.$cookies.get('nedas_lang')
      this.$store.dispatch('home/setLanguage', this.selected)
    }
    if (this.$cookies.get('hide_lang') && this.$cookies.get('hide_lang').trim() !== '') {
      this.hideLang = this.$cookies.get('hide_lang').split('.')
    }
    if (this.hideLang.length > 0) {
      let tempLang = []
      for (let i = 0; i < this.langs.length; i++) {
        if (this.hideLang.indexOf(this.langs[i]) === -1) {
          tempLang.push(this.langs[i])
        }
      }
      this.langs = tempLang
    }

    if (!this.langs.includes(this.selected)) {
      this.loadLanguageAsync(this.langs[0])
      this.selected = this.langs[0]
      this.$store.dispatch('home/setLanguage', this.selected)
    }
    this.$store.dispatch('home/setIsRTL', this.rtlLanguages.includes(this.selected))
  },
  methods: {
    setI18nLanguage: function (lang) {
      console.log('bbbbbbbbbbbbbbbbbbbbbb')
      this.$i18n.locale = lang
      this.$cookies.set('nedas_lang', lang)
      this.$store.dispatch('home/setIsRTL', this.rtlLanguages.includes(lang))
      this.$store.dispatch('home/setLanguage', lang)
    },
    loadLanguageAsync: function (lang) {
      if (this.$i18n.locale !== lang) {
        if (!this.loadedLanguages.includes(lang)) {
          return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(msgs => {
            this.$i18n.setLocaleMessage(lang, msgs[lang])
            this.loadedLanguages.push(lang)
            return this.setI18nLanguage(lang)
          })
        }
        return Promise.resolve(this.setI18nLanguage(lang))
      }
      return Promise.resolve(lang)
    }
  }
}
</script>
